var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"NotFound"},[_c('p',[_c('span',{ref:"left"},[_vm._v("4")]),_c('span',[_vm._v("0")]),_c('span',{ref:"right"},[_vm._v("4")])])])}
var staticRenderFns = []

export { render, staticRenderFns }